import { Box, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useContext } from 'react'
import { FaLongArrowAltDown, FaLongArrowAltUp } from 'react-icons/fa'

import { EntityListContext } from '../../../Contexts'
import { EntitySortOrder } from '../../../Hooks'

const SortSelect: React.FC = () => {
  const { sortOrder, updateSortOrder } = useContext(EntityListContext)

  const onSortChange = (event: SelectChangeEvent<EntitySortOrder>) => {
    updateSortOrder?.(event.target.value as EntitySortOrder)
  }

  return (
    <Select onChange={onSortChange} value={sortOrder} variant="standard">
      <MenuItem value={EntitySortOrder.LandAreaHighToLow}>
        <Box alignItems="center" display="flex" justifyContent="center">
          Land Area
          <FaLongArrowAltUp />
        </Box>
      </MenuItem>
      <MenuItem value={EntitySortOrder.LandAreaLowToHigh}>
        <Box alignItems="center" display="flex" justifyContent="center">
          Land Area
          <FaLongArrowAltDown />
        </Box>
      </MenuItem>
    </Select>
  )
}

export default SortSelect
